import { BlockTypes } from "../models/BlockTransportSystemJsonModel";
import { ProductCategoryTypes } from "./PolarProductList";

export interface BlockTypeConfig {
    blockType: BlockTypes;
    productCategories: ProductCategoryTypes[];
    isCutAvaliable?: boolean;
    isPhotoCardOriginAvaliable?: boolean;
    isPhotoCardSilverAvaliable?: boolean;
    isColorNamesLayoutAvaliable?: boolean;
    isTextColorPresetAvaliable?: boolean;
    isTextAlignAvaliable?: boolean;
}

export const getBlockTypeConfig = (blockType: string) => {
    const config = blockTypeConfigs.find(i => i.blockType === blockType);
    if (config) {
        return config;
    }

    return {
        blockType: blockType,
        productCategories: []
    } as BlockTypeConfig;
}

export const getBlockTypeConfigs = () => {
    return blockTypeConfigs.sort((a, b) => {
        if (a.blockType === 'none') return -1;   // a가 none이면 항상 앞으로
        if (b.blockType === 'none') return 1;    // b가 none이면 뒤로
        return a.blockType.localeCompare(b.blockType); // 나머지는 문자열 기준 오름차순
    });
}

export const blockTypeConfigs: BlockTypeConfig[] = [
    {
        blockType: BlockTypes.none,
        productCategories: []
    },
    {
        blockType: BlockTypes.colorNames,
        productCategories: [ProductCategoryTypes.ColorNames],
        isColorNamesLayoutAvaliable: true,
        isTextColorPresetAvaliable: true,
    },
    {
        blockType: BlockTypes.graphicNames,
        productCategories: [ProductCategoryTypes.GraphicNames],
        isTextColorPresetAvaliable: true,
        isTextAlignAvaliable: true,
    },
    {
        blockType: BlockTypes.graphicNames12cut,
        productCategories: [ProductCategoryTypes.GraphicNames],
        isTextColorPresetAvaliable: true,
        isTextAlignAvaliable: true,
    },
    {
        blockType: BlockTypes.photoCard,
        productCategories: [ProductCategoryTypes.PhotoCard],
        isPhotoCardOriginAvaliable: true,
        isPhotoCardSilverAvaliable: true
    },
    {
        blockType: BlockTypes.photoCardSilver,
        productCategories: [ProductCategoryTypes.PhotoCard],
        isPhotoCardOriginAvaliable: true,
        isPhotoCardSilverAvaliable: true
    },
    {
        blockType: BlockTypes.photoCardEvolis,
        productCategories: [ProductCategoryTypes.PhotoCard],
        isPhotoCardOriginAvaliable: true,
        isPhotoCardSilverAvaliable: false
    },
    {
        blockType: BlockTypes.cardCoverStickerDieCut,
        productCategories: [ProductCategoryTypes.CardCover],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.cardCoverStickerMini,
        productCategories: [ProductCategoryTypes.CardCover],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.cardCoverStickerNormal,
        productCategories: [ProductCategoryTypes.CardCover],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.cardCoverStickerToss,
        productCategories: [ProductCategoryTypes.CardCover],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.cardCoverStickerTransportation,
        productCategories: [ProductCategoryTypes.CardCover],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.sealSticker,
        productCategories: [ProductCategoryTypes.PhotoStickerDieCut],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.phoneCaseSticker,
        productCategories: [ProductCategoryTypes.PhotoStickerDieCut],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.plateSticker,
        productCategories: [ProductCategoryTypes.PhotoStickerDieCut],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.acrylicGoodsTheme,
        productCategories: [ProductCategoryTypes.PhotoStickerDieCut],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.waterGlitter,
        productCategories: [ProductCategoryTypes.PhotoStickerDieCut],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.pencil,
        productCategories: [ProductCategoryTypes.PhotoStickerDieCut],
        isCutAvaliable: true
    },
    {
        blockType: BlockTypes.theme,
        productCategories: [
            ProductCategoryTypes.PhotoSticker,
            ProductCategoryTypes.CardCover,
            ProductCategoryTypes.ColorNames,
            ProductCategoryTypes.GraphicNames],
    },
    {
        blockType: BlockTypes.stamp,
        productCategories: Object.values(ProductCategoryTypes),
    },
    {
        blockType: BlockTypes.integratedTheme,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.coverTheme,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.badge,
        productCategories: Object.values(ProductCategoryTypes),
    },
    {
        blockType: BlockTypes.featuredPhoto,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.selfCuttingSticker,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.selfCuttingStickerSquare,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.photoCollageSticker,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.paperToy,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.collaboCalendar,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.ipSpecial,
        productCategories: [ProductCategoryTypes.PhotoSticker, ProductCategoryTypes.PhotoCard],
    },
    {
        blockType: BlockTypes.iglooPhotoBooth,
        productCategories: [ProductCategoryTypes.PhotoSticker],
    },
    {
        blockType: BlockTypes.cheerUpSlogan,
        productCategories: [ProductCategoryTypes.CheerUp],
    },
];